import remimiLib from '@brandwatch/remimi';
import auth from '../../auth';
import {getUser} from '../../lib/tycho';

const capitalise = str => `${str[0].toUpperCase()}${str.substring(1)}`;

let getUserPromise;

// eslint-disable-next-line no-unused-vars
export const augmentMixpanel = store => next => action => {
  if (!action || !action.meta || !action.meta.mixpanel) {
    return next(action);
  }

  // Support convenient syntax for basic logging of an action happening.
  if (action.meta.mixpanel === 'auto') {
    action.meta.mixpanel = {
      eventName: action.type
    };
  }

  if (!getUserPromise) {
    getUserPromise = getUser();
  }

  return Promise.all([
    auth.getUserProfile().then(profile => profile.clientId),
    getUserPromise.then(user => user.client_type_id)
  ]).then(([
    clientId,
    clientTypeId
  ]) => {
    // Add prop that identifies the app from which a mixpanel event came,
    // and the user's client ID.
    action.meta.mixpanel.props = Object.assign(action.meta.mixpanel.props || {}, {
      app: 'bootstrap2',
      clientId,
      clientTypeId
    });

    return next(action);
  }).catch(err => {
    console.warn('Error logging to mixpanel.', err); // eslint-disable-line no-console
  });
};

// The middleware that actually sends events to mixpanel.
export const remimi = remimiLib(window.env.MIXPANEL_TOKEN, {
  config: {
    cross_subdomain_cookie: false
  },
  actionTypeFormatter: str => str.split(/_|\s/).map(w => capitalise(w.toLowerCase())).join(' ')
});
